<div class="row mt-2">
  <div class="col-12">
    <!-- TITULO -->
    <div class="row" *ngIf="!trainsInfo.isModal">
      <div class="col-12">
        <h3 class="heading-5">
          {{ "train.form-train.request-train-title" | translate }}
        </h3>
      </div>
    </div>
    <app-user-detail *ngIf="(trainsInfo.isAdmin && trainsInfo.canUseTRM) || trainsInfo.isEmployee"
      [userUuid]="trainsInfo.userToBook" (navigateEvent)="goBack()"></app-user-detail>

    <form [formGroup]="trainsInfo.formSearchTrain" class="search-card">
      <div class="trip-length-container">
        <div class="trip-length-selector-container">
          <div id="roundtrip" class="cursor-pointer" [ngClass]="{ active: trainsInfo.searchConfig.oneWay === false }"
            (click)="setOneWaySearch(false)">
            {{ "train.form-train.roundTripYes" | translate }}
          </div>
          <div id="oneWay" class="cursor-pointer" [ngClass]="{ active: trainsInfo.searchConfig.oneWay }"
            (click)="setOneWaySearch(true)">
            {{ "train.form-train.roundTripNo" | translate }}
          </div>
        </div>
      </div>
      <div class="origin-destination-container">
        <div class="input-containers col-5">
          <label class="origin-container train-station-container input-icon border-radius-20">
            <img src="assets/img/svg/train-orange.svg" />
            <input id="origin" placeholder="{{ 'train.form-train.location' | translate }}" matInput
              (input)="getStations($event.target.value)" [formControl]="trainsInfo.formSearchTrain.controls['origin']"
              [matAutocomplete]="from" />
            <mat-autocomplete (optionSelected)="optionSelected('origin', $event.option.value)" #from="matAutocomplete"
              panelWidth="30%" class="station-list">
              <mat-option *ngFor="let option of filteredStationList" class="station-item" [value]="option.name">
                <div class="option-text">
                  <div class="icon">
                    <img src="assets/img/svg/location.svg" />
                  </div>
                  <div class="info">
                    <div class="station-name">{{ option.name }}</div>
                  </div>
                  <div class="country-code">{{ option.country }}</div>
                </div>
              </mat-option>
            </mat-autocomplete>
          </label>
        </div>
        <button class="button-secondary col-1" (click)="switchOriginDestination()">
          <img src="assets/img/svg/train/switch.svg" alt="switch" />
        </button>
        <div class="input-containers col-5">
          <label class="destination-container train-station-container input-icon border-radius-20">
            <img src="assets/img/svg/train-orange.svg" />
            <input id="destination" placeholder="{{ 'train.form-train.location' | translate }}" matInput
              (input)="getStations($event.target.value)"
              [formControl]="trainsInfo.formSearchTrain.controls['destination']" [matAutocomplete]="to" />
            <mat-autocomplete (optionSelected)="optionSelected('destination', $event.option.value)"
              #to="matAutocomplete" panelWidth="30%" class="station-list">
              <mat-option *ngFor="let option of filteredStationList" class="station-item" [value]="option.name">
                <div class="option-text">
                  <div class="icon">
                    <img src="assets/img/svg/location.svg" />
                  </div>
                  <div class="info">
                    <div class="station-name">{{ option.name }}</div>
                  </div>
                  <div class="country-code">{{ option.country }}</div>
                </div>
              </mat-option>
            </mat-autocomplete>
          </label>
        </div>
      </div>
      <div class="other">
        <div class="date-container" [ngClass]="{oneWay: trainsInfo.searchConfig.oneWay}">
          <div class="outward">
            <label for="">{{ "flights.form.dateIn" | translate }}</label>
            <div class="datetime">
              <label class="input-icon border-radius-20">
                <img src="assets/img/svg/calendar-orange.svg" />
                <input placeholder="{{ 'train.form-train.departure-date' | translate }}" [minDate]="getInMinDate()"
                  [maxDate]="trainsInfo.formSearchTrain.get('returnDate').value" (ngModelChange)="onDateChange()"
                  (click)="dInput.toggle()" ngbDatepicker #dInput="ngbDatepicker" formControlName="departDate" />
              </label>
              <div class="input-icon border-radius-20 timepicker-wrapper">
                <ngb-timepicker
                  formControlName="departTime"
                  [spinners]="false"
                ></ngb-timepicker>
              </div>
            </div>
          </div>
          <div class="return" *ngIf="trainsInfo.searchConfig.oneWay === false">
            <label for="">{{ "flights.form.dateOut" | translate }}</label>
            <div class="datetime">
              <label class="input-icon border-radius-20">
                <img src="assets/img/svg/calendar-orange.svg" />
                <input placeholder="{{ 'train.form-train.return-date' | translate }}" [minDate]="getOutMinDate()"
                  (ngModelChange)="onDateChange()" (click)="dInput.toggle()" ngbDatepicker #dInput="ngbDatepicker"
                  formControlName="returnDate" />
              </label>
              <div class="input-icon border-radius-20 timepicker-wrapper">
                <ngb-timepicker
                  formControlName="returnTime"
                  [spinners]="false"
                ></ngb-timepicker>
              </div>
            </div>
          </div>
          <div class="passengers-container">
            <label class="project-label">{{'project.my-projects.travelers' | translate}}</label>
            <div class="passenger-summary" (click)="togglePassengersModal()">
              <img class="passenger-summary-icon-left" src="assets/img/svg/orange-person.svg" alt="Person" />
              <span class="passenger-summary-text">{{ travellers.length }} {{ 'train.form-train.travelers' | translate | lowercase }}</span>
            </div>
            <div class="passenger-modal-overlay" *ngIf="passengersModalOpen" (click)="closePassengersModal()"></div>
            <div class="passenger-modal-container" [ngClass]="{ 'modal-open-custom': openModal }" *ngIf="passengersModalOpen">
              <div class="passengers-modal" (click)="$event.stopPropagation()">
                <div class="modal-content">
                  <div class="travellers-container">
                    <div *ngFor="let traveller of travellers; let i = index; trackBy: trackByIndex"
                      class="traveller-dropdown" style="font-size: 10px">
                      <mat-form-field appearance="fill" class="travellers traveler-selector">
                        <mat-select #select id="traveller-{{ i }}" [(value)]="travellers[i]" (closed)="onPanelClose()"
                          [disabled]="i === 0" (openedChange)="onOpenedChange($event, input)" [compareWith]="compareUsers">
                          <mat-select-trigger *ngIf="travellers[i]">
                            {{ travellers[i]?.name }} {{ travellers[i]?.lastname }}
                          </mat-select-trigger>
                        
                          <mat-option>
                            <input class="custom-mat-input" #input matInput (input)="applyFilter($event.target.value)"
                              (click)="$event.stopPropagation()" placeholder="{{ 'common.search-user' | translate }}" />
                          </mat-option>
                          <mat-option *ngFor="let user of filteredUsers" [value]="user">
                            {{ user.name }} {{ user.lastname }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <div ngbDropdown>
                        <div class="card-select-container">
                          <div *ngIf="trainsInfo.trainCards.length > 0" ngbDropdownToggle
                            class="dropdown-toggle border-radius-20 cursor-pointer">
                            {{
                            traveller.selectedCard != null
                            ? traveller.selectedCard.name
                            : ("train.form-train.add-discount-card" | translate)
                            }}
                          </div>
                          <div ngbDropdownMenu class="dropdown-menu border-radius-20" aria-labelledby="dropdownBasic1">
                            <p ngbDropdownItem (click)="selectCard(null, traveller)" [ngClass]="{
                            selected: traveller.selectedCard === null
                          }">
                              {{ "train.none" | translate }}
                            </p>
                            <p ngbDropdownItem *ngFor="let trainCard of trainsInfo.trainCards; let i = index"
                              (click)="selectCard(trainCard, traveller)" [ngClass]="{
                            selected: trainCard.code === traveller?.selectedCard?.code,
                            last: trainsInfo.trainCards.length - 1 === i
                          }">
                              {{ trainCard?.name }}
                            </p>
                          </div>
                          <label class="origin-container train-station-container input-icon border-radius-20"
                            *ngIf="traveller.selectedCard">
                            <input (input)="onCardNumberChange($event, traveller)"
                              [placeholder]="'company.card.paNumber' | translate" />
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="add-passengers-container">
                    <button class="remove-btn add-passengers-btn" [disabled]="travellers.length < 2" (click)="changeTravellers('remove')">{{ "common.remove-passenger" | translate }}</button>
                    <button class="add-passengers-btn" (click)="changeTravellers('add')">{{ "common.add-passenger" | translate }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="options-travel">
        <label class="project-label">{{'project.project-assign' | translate}}</label>
        <div class="d-flex align-items-center row">
          <div class="input-group col-4"
            [ngClass]="{ 'disabled-input': loadingProjects || !trainsInfo.formSearchTrain.get('departDate').value || (!trainsInfo.formSearchTrain.get('returnDate').value && !trainsInfo.searchConfig.oneWay) }">
            <select name="" id="" class="form-control form-control--squared select-input custom-select"
              formControlName="selectedProject"
              [disabled]="loadingProjects || !trainsInfo.formSearchTrain.get('departDate').value || (!trainsInfo.formSearchTrain.get('returnDate').value && !trainsInfo.searchConfig.oneWay)">
              <option [ngValue]="null" disabled selected>{{'project.project-select' | translate}}</option>

              <option *ngFor="let project of projects" [ngValue]="project">
                {{ project.title }}
              </option>
            </select>
          </div>

          <button *ngIf="!loadingProjects" class="btn no-focus-border" (click)="openTravelDialog()"
            [disabled]="loadingProjects || !trainsInfo.formSearchTrain.get('departDate').value || (!trainsInfo.formSearchTrain.get('returnDate').value && !trainsInfo.searchConfig.oneWay)">
            <img src="assets/img/svg/add-booking-circle.svg" alt="Add booking" />
          </button>
          <i style="margin-left: 0.5rem; font-size: 1.5rem;" class="ft-loader" *ngIf="loadingProjects"></i>
        </div>
      </div>

      <button (click)="onSearch()" [disabled]="trainsInfo.formSearchTrain.valid === false"
        class="button-primary custom-btn">
        <!--   <button (click)="onSearch()" class="button-primary custom-btn"
  [disabled]="
    !trainsInfo.formSearchTrain.valid ||
    (!trainsInfo.searchConfig.oneWay &&
      (!trainsInfo.formSearchTrain.get('returnDate').value) || !alltravellersSelected())
  "> -->
        {{ "train.form-train.search-trains" | translate }}
      </button>
      <div *ngIf="searchHasFailed" class="search-has-failed-container">
        <p>
          {{ "common.search-fail-custom-service.title" | translate }}
        </p>
        <button class="button-secondary" (click)="
        trainsInfo.userFilters.requestCustomTrain
          ? goToCreateCustomTrain()
          : utilsService.openChat()
      ">
          {{
          (trainsInfo.userFilters.requestCustomTrain
          ? "common.search-fail-custom-service.button"
          : "common.open-chat"
          ) | translate
          }}
        </button>
      </div>
    </form>
  </div>
</div>